// src/pages/Admin/Notifications/components/PreviewModal.tsx

import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box,
  Grid,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";

interface Props {
  open: boolean;
  onClose: () => void;
  title: string;
  message: string;
  imageUrl?: string;
}

const PreviewModal: React.FC<Props> = ({
  open,
  onClose,
  title,
  message,
  imageUrl,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          overflow: "hidden",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: "1px solid #F0F0F0",
          py: 1.5,
          px: 3,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            sx={{
              width: 32,
              height: 32,
              borderRadius: "50%",
              bgcolor: "#FFE8E3",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <NotificationsNoneOutlinedIcon
              sx={{ color: "#D91F05", fontSize: 18 }}
            />
          </Box>
          <Typography sx={{ fontSize: 16, fontWeight: 600 }}>
            Pré-visualização da notificação
          </Typography>
        </Box>

        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ px: 4, py: 3 }}>
        <Grid container spacing={4} alignItems="stretch">
          {/* Coluna esquerda: título + mensagem */}
          <Grid item xs={12} md={7}>
            <Box
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Typography
                variant="h5"
                sx={{ fontWeight: 700, mb: 2, fontSize: 24 }}
              >
                {title}
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  whiteSpace: "pre-line", // respeita quebras de linha no texto
                  fontSize: 14,
                  lineHeight: 1.6,
                  color: "#444444",
                }}
              >
                {message}
              </Typography>
            </Box>
          </Grid>

          {/* Coluna direita: imagem */}
          <Grid item xs={12} md={5}>
            {imageUrl ? (
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Box
                  component="img"
                  src={imageUrl}
                  alt="Imagem da notificação"
                  sx={{
                    maxWidth: "100%",
                    maxHeight: 420,
                    borderRadius: 1,
                    boxShadow: "0px 2px 8px rgba(0,0,0,0.08)",
                    objectFit: "contain",
                  }}
                />
              </Box>
            ) : (
              <Box
                sx={{
                  height: "100%",
                  minHeight: 180,
                  borderRadius: 2,
                  border: "1px dashed #D0D0D0",
                  bgcolor: "#FAFAFA",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                  px: 2,
                }}
              >
                <NotificationsNoneOutlinedIcon
                  sx={{ fontSize: 40, color: "#B0B0B0", mb: 1.5 }}
                />
                <Typography sx={{ fontSize: 14, fontWeight: 600, mb: 0.5 }}>
                  Nenhuma imagem adicionada
                </Typography>
                <Typography sx={{ fontSize: 12, color: "#777" }}>
                  A notificação será exibida apenas com título e mensagem.
                  <br />
                  Opcionalmente, adicione uma imagem para destacar esse aviso no
                  portal.
                </Typography>
              </Box>
            )}
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default PreviewModal;
